import React, { useState, useMemo } from "react";
import { useProductsStore } from "../../stores/productsStore";
import ProductsSummaryPanel from "./ProductsSummaryPanel";
import ProductsBulkActions from "./ProductsBulkActions";
import {
  SearchBar,
  RefreshButton,
  FilterModal,
  FilterButton,
  PermissionWrapper,
  AnimatedCheckboxButton,
} from "components";
import { zeroStocksIcon } from "assets";

// Компонент заголовку сторінки "Товари постачальників"
const ProductsHeader = () => {
  // Отримуємо дані та дії безпосередньо зі стору
  const isLoading = useProductsStore((state) => state.isLoading);
  const fetchProducts = useProductsStore((state) => state.fetchProducts);
  const filters = useProductsStore((state) => state.filters);
  const applyFilters = useProductsStore((state) => state.applyFilters);
  const setSearch = useProductsStore((state) => state.setSearch);
  const suppliers = useProductsStore((state) => state.suppliers);
  const productData = useProductsStore((state) => state.products);
  const categoryOptions = useProductsStore((state) => state.categoryOptions);
  const setIsOnShop = useProductsStore((state) => state.setIsOnShop);

  // Локальний стан для керування видимістю модального вікна фільтрів
  const [isFilterOpen, setFilterOpen] = useState(false);

  const currentSkusOnPage = useMemo(() => {
    return (productData || []).map((item) => item.article);
  }, [productData]);

  return (
    <div className="productspage-title">
      <div className="productspage-title-line">
        <div className="title-container">
          <RefreshButton onRefresh={fetchProducts} disabled={isLoading} />
          <h3>Товари постачальника</h3>

          <div className="search-container">
            <SearchBar value={filters.search} onSearch={(value) => setSearch(value)} />
            <FilterButton
              onClick={() => setFilterOpen(true)}
              isActive={
                filters.supplier_id !== null ||
                filters.status !== null ||
                filters.category_id !== null
              }
            />
            <FilterModal
              isOpen={isFilterOpen}
              onClose={() => setFilterOpen(false)}
              onApply={applyFilters}
              filters={[
                {
                  id: "status",
                  label: "Статус",
                  options: ["available", "order", "not available"],
                  value: filters.status,
                  placeholder: "Всі статуси",
                },
                {
                  id: "supplier_id",
                  label: "Постачальник",
                  options: suppliers,
                  value: filters.supplier_id,
                  placeholder: "Всі постачальники",
                  valueKey: "id",
                  labelKey: "name",
                },
                {
                  id: "category_id",
                  label: "Категорія",
                  options: categoryOptions,
                  value: filters.category_id,
                  placeholder: "Усі категорії",
                  type: "autocomplete",
                  valueKey: "id",
                  labelKey: "name",
                },
              ]}
            />
          </div>
        </div>
        <PermissionWrapper requiredPermission="products:edit">
          <div className="bulk-actions-wrapper">
            <ProductsBulkActions
              currentSkusOnPage={currentSkusOnPage}
              isEmpty={!currentSkusOnPage.length}
            />
          </div>
        </PermissionWrapper>
      </div>

      <div className="productspage-title-line">
        <ProductsSummaryPanel />
        <div className="on-shop-btn">
          <AnimatedCheckboxButton
            id="product-is-on-shop-toggle"
            label="Тільки на Prom"
            icon={zeroStocksIcon}
            checked={filters.is_on_shop === true}
            onChange={(e) => setIsOnShop(e.target.checked ? true : null)}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductsHeader;
